import { getGuessStatuses } from './statuses'
import { getWordOfDayIndex } from './words'

export const shareStatus = (guesses: string[], wordIndex: number) => {
    navigator.clipboard.writeText(
        `Зборле ${getWordOfDayIndex()} ${guesses.length}/6\n\n${generateEmojiGrid(
            guesses,
            wordIndex
        )}\n\nИграјте ЗБОРЛЕ https://zborle.mk`
    )
}

export const generateEmojiGrid = (guesses: string[], wordIndex: number) => {
    return guesses
        .map((guess) => {
            const status = getGuessStatuses(guess, wordIndex)
            return guess
                .split('')
                .map((letter, i) => {
                    switch (status[i]) {
                        case 'correct':
                            return '🟩'
                        case 'present':
                            return '🟨'
                        default:
                            return '⬜'
                    }
                })
                .join('')
        })
        .join('\n')
}
